import React from 'react';
import { RouterProvider, createBrowserRouter } from "react-router-dom";
import { useJWTAuth } from "./JWTAuthProvider";
import { ProtectedRoute } from "./ProtectedRoute";
import { LoginMain } from '../components/login-main';
import { Login } from '../components/login/index';
import { ResetPassword } from '../components/reset-password/index';
import { LandingPage } from '../components/landing-page';
import { ExportFile } from '../components/export-file';
import { UserManagement } from '../components/user-management';
import { Configuration } from '../components/configuration';
import { AddUser } from '../components/user-management/add-user';
import { EditUser } from '../components/user-management/edit-user';
import Loader from "react-js-loader";

const Routes = () => {
    const { isAuthenticated, isLoading, inProgress } = useJWTAuth();

    // Define public routes accessible to all users
    const routesForPublic = [];
    // Define routes accessible only to authenticated users
    const routesForAuthenticatedOnly = [
        {
            element: <ProtectedRoute />, // Wrap the component in ProtectedRoute
            children: [
                {
                    path: "/:folderId?",
                    element: <LandingPage />,
                }, {
                    path: "/ExportFiles/:id",
                    element: <ExportFile />,
                },
                {
                    path: "/usermanagement",
                    element: <UserManagement />,
                },
                {
                    path: "/configuration",
                    element: <Configuration />,
                },
                {
                    path: "/adduser",
                    element: <AddUser />,
                },
                {
                    path: "/edituser",
                    element: <EditUser />,
                },
            ],
        },
    ];

    // Define routes accessible only to non-authenticated users
    const routesForNotAuthenticatedOnly = [
        // {
        //     path: "/",
        //     element: <LoginMain />,
        // },
        {
            path: "/login",
            element: <Login />,
        },
        {
            path: "/resetpassword",
            element: <ResetPassword />,
        }
    ];

    // Combine and conditionally include routes based on authentication status
    const router = createBrowserRouter([
        ...routesForPublic,
        ...(!isAuthenticated ? routesForNotAuthenticatedOnly : []),
        ...routesForAuthenticatedOnly,
    ]);
    // Provide the router configuration using RouterProvider
    return isLoading || inProgress !== "none" ? <Loader type="bubble-spin" bgColor={"#e07083"} color={"#000"} title={"Loading"} size={100} />
        : <RouterProvider router={router} />;
};

export default Routes;